import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { NotificationTypes } from '@app/shared/enums';

@Component({
  selector: 'app-banner',
  imports: [CommonModule, MatIconModule],
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  standalone: true,
})
export class BannerComponent {
  @Input() type: NotificationTypes;

  public get icon(): string {
    switch (this.type) {
      case NotificationTypes.DANGER:
        return 'error';
      case NotificationTypes.INFO:
        return 'info';
      case NotificationTypes.SUCCESS:
        return 'check_circle';
      case NotificationTypes.WARN:
        return 'fmd_bad';
    }
  }
}
